import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, of, throwError } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { EntiService } from './enti.service';

@Injectable({
  providedIn: 'root'
})
export class EntiDataSource implements DataSource<ModelEventiCalamitosi.EnteDto> {

  public enteSubject = new BehaviorSubject<ModelEventiCalamitosi.EnteDto[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  private errorSubject = new BehaviorSubject<boolean>(false);
  public errors$ = this.errorSubject.asObservable();
  public loadCompleteEnte = new BehaviorSubject<boolean>(false);
  public sonoTuttiApertiRaccDat = new BehaviorSubject<number>(-1);
  public sonoTuttiApertiCorrDat = new BehaviorSubject<number>(-1);
  isLoading: boolean = false;
  errorMessage: string = null;

  private countSubject = new BehaviorSubject<number>(0);
  public counter$ = this.countSubject.asObservable();

  constructor(private entiService: EntiService) {
  }

  loadEnti(
    controlList: ModelEventiCalamitosi.EnteDto[],
    filter: ModelEventiCalamitosi.EnteSearchableDto,
    sortDirection: string,
    pageIndex: number,
    pageSize: number,
    distribuito?: string,
    allAb?: string,
    allModStatoComp?: string) {

    this.loadingSubject.next(true);

    this.entiService.getList(pageIndex, pageSize, sortDirection, {
      idTemplate: filter.idTemplate,
      idEnte: filter.idEnte,
      descrizione: filter.descrizione,
      provincia: filter.provincia,
      tipologiaEnte: filter.tipologiaEnte,
      statoCorrezioneDati: filter.statoCorrezioneDati,
      statoRaccoltaDati: filter.statoRaccoltaDati,
      abilitato: filter.abilitato
    }).pipe(
      catchError(err => {
        this.errorSubject.next(true);
        return throwError(err);
      }),
      catchError(err => {
        return of([]);
      }),
      finalize(() => this.loadingSubject.next(false))
    )
      .subscribe(result => {
        let listEnti: ModelEventiCalamitosi.EnteDto[] = result['content'];
        /**
         * fix
         */
        if (allAb) {
          if (allAb === 'S') {
            listEnti.forEach(element => {
              if (distribuito === 'S') {
                if (element.abilitato === 'N' || !element.abilitato) element.editatoFE = true;
              }
              element.abilitato = 'S';
            });
            listEnti.forEach(element => {
              let present: boolean = false;
              controlList.forEach(controlEle => {
                if (controlEle.nodeCode === element.nodeCode) present = true;
              });
              if (present) element.abilitato = 'N';
            });
          } else if (allAb === 'N') {
            listEnti.forEach(element => {
              if (distribuito === 'S') {
                if (element.abilitato === 'N') {
                  element.editatoFE = true;
                }
              } else element.abilitato = 'N';
            });
            listEnti.forEach(element => {
              let present: boolean = false;
              controlList.forEach(controlEle => {
                if (controlEle.nodeCode === element.nodeCode) present = true;
              });
              if (present) element.abilitato = 'S';
            });
          }
        }
        else {
          listEnti.forEach(element => {
            controlList.forEach(controlEle => {
              if (controlEle.nodeCode === element.nodeCode && controlEle.abilitato !== element.abilitato) {
                element.abilitato = controlEle.abilitato;
                element.editatoFE = true;
              }
            });
          });
        }

        if (allModStatoComp) {
          if (allModStatoComp === 'S') {
            listEnti.forEach(element => {
              if (element.modificato === 'N' || !element.modificato) element.modificatoFE = true;
              element.modificato = 'S';
            });
            listEnti.forEach(element => {
              let present: boolean = false;
              controlList.forEach(controlEle => {
                if (controlEle.nodeCode === element.nodeCode) present = true;
              });
              if (present) element.modificato = 'N';
            });
          } else if (allModStatoComp === 'N') {
            listEnti.forEach(element => {
              if (element.modificato === 'N') {
                element.modificatoFE = true;
              } else element.modificato = 'N';
            });
            listEnti.forEach(element => {
              let present: boolean = false;
              controlList.forEach(controlEle => {
                if (controlEle.nodeCode === element.nodeCode) present = true;
              });
              if (present) element.modificato = 'S';
            });
          }
        }
        else {
          listEnti.forEach(element => {
            controlList.forEach(controlEle => {
              if (controlEle.nodeCode === element.nodeCode && controlEle.modificato !== element.modificato) {
                element.modificato = controlEle.modificato;
                element.modificatoFE = true;
              }
            });
          });
        }

        // Per poter caricare i bottoni nella pagina
        // della lista di enti restituisco due variabili
        // valorizzate a true solo quando ogni elemento
        // della lista risulta essere in uno stato adeguato
        // per compiere l'azione dello specifico bottone
        var numStatoApe = 0;
        var numStatoChi = 0;
        var numStatoCorrApe = 0;
        var numStatoCorrChi = 0;

        listEnti.forEach(element => {
          if (element.stato == "APE") {
            numStatoApe += 1;
          } else if (element.stato == 'CHI') {
            numStatoChi += 1;
          }
          if (element.statoCorrezioneDati == 'APE') {
            numStatoCorrApe += 1;
          } else if (element.statoCorrezioneDati == "CHI") {
            numStatoCorrChi += 1;
          }
        })

        if (numStatoApe > 0 && numStatoApe == listEnti.length) {
          this.sonoTuttiApertiRaccDat.next(0);
        } else if (numStatoChi > 0 && numStatoChi == listEnti.length) {
          this.sonoTuttiApertiRaccDat.next(1);
        } else {
          this.sonoTuttiApertiRaccDat.next(-1);
        }

        if (numStatoCorrApe > 0 && numStatoCorrApe == listEnti.length) {
          this.sonoTuttiApertiCorrDat.next(0);
        } else if (numStatoCorrChi > 0 && numStatoCorrChi == listEnti.length) {
          this.sonoTuttiApertiCorrDat.next(1);
        } else {
          this.sonoTuttiApertiCorrDat.next(-1);
        }

        this.enteSubject.next(listEnti);
        this.loadCompleteEnte.next(true);
        this.countSubject.next(result['totalElements']);
      }
      );
  }

  connect(collectionViewer: CollectionViewer): Observable<ModelEventiCalamitosi.EnteDto[]> {
    return this.enteSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.enteSubject.complete();
    this.loadingSubject.complete();
  }

}

